import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import * as Cookie from "js-cookie";

import alert from "./modules/alert";
import account from "./modules/account";
import users from "./modules/users";
import cart from "./modules/cart";

import state from "./state";
import getters from "./getters";
import * as actions from "./actions";
import * as mutations from "./mutations";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    alert,
    account,
    users,
    cart
  },
  plugins: [
    createPersistedState({
      paths: ["account.token"],
      key: "user",
      reducer: state => ({
        info: state.account.info,
        token: state.account.token
      }),
      storage: {
        getItem: key => Cookie.get(key),
        setItem: (key, state) =>
          Cookie.set(key, state, {
            expires: 3,
            secure: false
          }),
        removeItem: key => Cookie.remove(key)
      }
    })
  ],
  strict: process.env.NODE_ENV !== "production"
});
